import { createAuthenticatedApi } from "@/lib/utils";
import {
  ClassEnrollmentsApi,
  type GetEnrollmentResponse,
} from "@/openapi/generated";

export async function fetchEnrollmentById(
  accessToken: string,
  tenantId: number | null | undefined,
  enrollmentId: number,
): Promise<GetEnrollmentResponse | null> {
  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  try {
    return await service.getEnrollmentById({
      id: enrollmentId,
      ...(tenantId != null && tenantId > 0 ? { xTenantID: tenantId } : {}),
    });
  } catch {
    return null;
  }
}
